import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import AudioPlayer from './components/AudioPlayer.tsx';
import BouncingDuck from './components/BouncingDuck.tsx';

function App() {
  const circleRef = useRef<HTMLDivElement>(null);
  const lastMoveTime = useRef(0);

  useEffect(() => {
    const circle = circleRef.current;
    if (!circle) return;

    // Throttled mouse move handler
    const handleMouseMove = (e: MouseEvent) => {
      const now = Date.now();
      if (now - lastMoveTime.current < 16) return; // ~60fps throttle
      lastMoveTime.current = now;

      const rect = circle.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const deltaX = (e.clientX - centerX) / 30;
      const deltaY = (e.clientY - centerY) / 30;

      circle.style.transition = 'transform 0.3s ease-out';
      circle.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="App">
      <div className="glass-container">
        <div ref={circleRef} className="glowing-circle">
          <div className="noise-layer"></div>
          <div className="sun-core"></div>
          <div className="inner-glow"></div>
        </div>
      </div>
      <AudioPlayer />
      <BouncingDuck />
    </div>
  );
}

export default App;
